module.exports = "https://static.wanderu.com/ui-react/_next/static/media/iphone-carriers.6b75cd37.png";